import React from 'react';
import './output.css'; // Import the compiled Tailwind CSS
import AIChatApp from './pages/AIChatApp';
// npx @tailwindcss/cli -i ./src/index.css -o ./src/output.css

function App() {
  return (
    <div className="App">
      <AIChatApp />
    </div>
  );
}

export default App;